import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/faq-icon.svg'


const _hoisted_1 = ["href"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "floating-menu-item-name" }

import { computed } from 'vue'
import { i18n } from '@/services/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutFloatingMenuFAQEntry',
  props: {
  translationKey: { type: String, required: true },
  externalLink: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const label = computed(() => {
  return i18n.global.t(props.translationKey)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.externalLink,
    target: "_blank"
  }, [
    _createElementVNode("img", {
      src: _imports_0,
      alt: label.value
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(label.value), 1 /* TEXT */)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})